import type { CSSProperties } from "react";

const baseStyle: CSSProperties = {
  height: "50px",
  width: "240px",
  border: "none",
  textAlign: "center",
  verticalAlign: "center",
  boxShadow: "0 2px 4px 0 rgba(0,0,0,.25)",
  fontSize: "16px",
  lineHeight: "48px",
  display: "block",
  borderRadius: "1px",
  transition: "background-color .218s, border-color .218s, box-shadow .218s",
  fontFamily: "Roboto,inter,arial,sans-serif",
  cursor: "pointer",
  userSelect: "none",
};

export const darkStyle: CSSProperties = {
  backgroundColor: "#4285f4",
  color: "#fff",
  ...baseStyle,
};

export const lightStyle: CSSProperties = {
  backgroundColor: "#fff",
  color: "rgba(0,0,0,.54)",
  ...baseStyle,
};

export const iconStyle: CSSProperties = {
  width: "48px",
  height: "48px",
  textAlign: "center",
  verticalAlign: "center",
  display: "block",
  marginTop: "1px",
  marginLeft: "1px",
  float: "left",
  backgroundColor: "#fff",
  borderRadius: "1px",
  whiteSpace: "nowrap",
};

export const svgStyle: CSSProperties = {
  width: "48px",
  height: "48px",
  display: "block",
};
